"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ajaxStatusReducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var types = _interopRequireWildcard(require("../actions/actionTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  callsInProgress: 0,
  isLoading: false,
  saveAttempts: 0,
  isInitialized: false,
  isDoneWithRulesBasedChanges: false,
  priceCalls: 0,
  priceLoading: false,
  isLongLoad: false
};
function ajaxStatusReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var newState = _objectSpread(_objectSpread({}, state), {}, {
    isDoneWithRulesBasedChanges: false
  });

  // eslint-disable-next-line default-case
  switch (action.type) {
    case types.BEGIN_AJAX_LOAD:
      newState.isLoading = true;
      newState.loadingMessage = action.loadingMessage;
      newState.isLongLoad = !!action.isLongLoad;
      break;
    case types.CLEAR_STATE:
    case types.END_AJAX_LOAD:
      if (newState.isLongLoad) {
        if (action.externalClose) {
          newState.isLoading = false;
        }
      } else {
        newState.isLoading = false;
      }
      break;
    case types.BEGIN_AJAX_CALL:
      newState.callsInProgress += 1;
      break;
    case types.CONFIGURATOR_LOAD:
      newState = _objectSpread(_objectSpread({}, state), initialState);
      break;
    case types.CONFIGURATOR_LOAD_SUCCESS:
      newState.isInitialized = true;
      break;
    case types.CONFIGURATOR_LOAD_FAILURE:
      newState.isInitialized = true;
      break;
    case types.AJAX_CALL_ERROR:
    case types.LOAD_OPTIONS_SUCCESS:
    case types.LOAD_TEMPLATES_SUCCESS:
    case types.LOAD_UNAVAILABLE_CHOICES_SUCCESS:
    case types.LOAD_DICTIONARY_TERMS_SUCCESS:
    case types.UPDATE_CONFIGURATOR_SUCCESS:
    case types.GET_VISUALIZER_IMAGE_URL_SUCCESS:
    case types.ESTIMATED_ARRIVAL_TIME_CHANGED_SUCCESS:
    case types.EXECUTE_RULES_SUCCESS:
      newState.callsInProgress -= 1;
      break;
    case types.PRICE_CHANGED_BEGIN:
      newState.priceCalls += 1;
      newState.priceLoading = true;
      break;
    case types.PRICE_CHANGED_SUCCESS:
    case types.PRICE_CHANGED_FAILURE:
      newState.callsInProgress -= 1;
      newState.priceCalls -= 1; // track pricing calls separately
      newState.priceLoading = !(newState.priceCalls === 0);
      break;
    case types.UPDATE_DISABLED_CHOICES:
      newState.isDoneWithRulesBasedChanges = true;
      break;
    case types.TRY_SAVE:
      newState.saveAttempts += 1;
      break;
  }
  return newState;
}
//# sourceMappingURL=ajaxStatusReducer.js.map